<div class="group-wrapper" *ngFor="let group of filterCriteriaDataService.groups; let groupIndex = index">

    <!-- GROUP HEADER -->
    <div class="group-header">
        <!-- accordion / expand-collapse icon -->
        <sh-icon [icon]="group.collapsed ? 'arrow-line-right-s' : 'arrow-line-down-s'" class="group-accordion-icon"
            button (click)="toggleGroupCollapse(groupIndex)">
        </sh-icon>

        <!-- group name field -->
        <div class="group-name-wrapper">
            <sh-input-text [id]="'tt-group-' + (isModal ? 'm' : 'p') + '-' + groupIndex" class="group-name-input"
                placeholder="Group name" label="" [(ngModel)]="group.name" condensed
                [disabled]="dataService.isRolloutUpdated">
            </sh-input-text>
            <!-- comment indicator overlaid on the input's right corner (only when notes exist) -->
            <sh-icon *ngIf="notesRef.noteCount > 0" icon="comment" class="group-name-notes-icon" button
                [id]="'tt-group-notes-' + (isModal ? 'm' : 'p') + '-' + groupIndex" (keydown.enter)="notesRef.openNotes($event)" (click)="notesRef.openNotes($event)">
            </sh-icon>
        </div>
        <sh-tooltip delay [target]="'tt-group-' + (isModal ? 'm' : 'p') + '-' + groupIndex"
            [label]="'filter-criteria.tooltip.group' | translate" placement="top" variation="short"></sh-tooltip>
        <sh-tooltip *ngIf="notesRef.noteCount > 0" delay
            [target]="'tt-group-notes-' + (isModal ? 'm' : 'p') + '-' + groupIndex" label="View notes" placement="top"
            variation="short"></sh-tooltip>

        <!-- group header actions -->
        <div class="group-header-actions">
            <!-- remove group -->
            <sh-icon [id]="'tt-grp-rm-' + (isModal ? 'm' : 'p') + '-' + groupIndex" icon="minus-light"
                class="group-header-icon" button (keydown.enter)="openDeleteGroupConfirm(groupIndex)" (click)="openDeleteGroupConfirm(groupIndex)"
                [disabled]="dataService.isRolloutUpdated">

            </sh-icon>
            <sh-tooltip delay [target]="'tt-grp-rm-' + (isModal ? 'm' : 'p') + '-' + groupIndex"
                [label]="'filter-criteria.tooltip.removeRow' | translate" placement="top"
                variation="short"></sh-tooltip>

            <!-- add new row in this group -->
            <sh-icon [id]="'tt-grp-add-' + (isModal ? 'm' : 'p') + '-' + groupIndex" icon="plus-light"
                class="group-header-icon" button (click)="addRow(groupIndex)" [disabled]="dataService.isRolloutUpdated">
            </sh-icon>
            <sh-tooltip delay [target]="'tt-grp-add-' + (isModal ? 'm' : 'p') + '-' + groupIndex"
                [label]="'filter-criteria.tooltip.addRow' | translate" placement="top" variation="short"></sh-tooltip>

            <app-filter-criteria-group-notes #notesRef [groupIndex]="groupIndex" [groupId]="group.id || ''" [groupName]="group.name || ''" (duplicateWithoutNotes)="duplicateGroupWithoutNotes($event)" (deleteGroup)="openDeleteGroupConfirm($event)" (notify)="notification = $event"></app-filter-criteria-group-notes>
        </div>
    </div>

    <!-- GROUP BODY: all rows of this group -->
    <div class="group-body" *ngIf="!group.collapsed" [id]="'group-drop-' + groupIndex" cdkDropList
        [cdkDropListConnectedTo]="connectedDropLists" [cdkDropListData]="group.conditions"
        (cdkDropListDropped)="drop($event, groupIndex)">
        <div *ngFor="let cond of group.conditions; let ci = index" class="filter-row"
            [id]="'cond-row-' + groupIndex + '-' + ci" [ngClass]="{ 'nested-row': cond.depth && cond.depth > 0 }"
            [style.padding-left.px]="getRowPadding(cond)" cdkDrag
            [cdkDragData]="{ groupIndex: groupIndex, conditionIndex: ci }"
            (cdkDragStarted)="onDragStarted($event, groupIndex, ci)">

            <ng-template cdkDragPreview>
                <div class="drag-preview-single">
                    <div *ngFor="let item of conditionsToBeMoved; let i = index" class="drag-preview-row">
                        <ng-container *ngTemplateOutlet="dragConditionsToBeMoved;
                            context: {
                              ci: i,
                              cond: item,
                              group: group,
                              groupIndex: groupIndex
                            }">
                        </ng-container>
                    </div>
                </div>
            </ng-template>
            <!-- drag handle for the row -->
            <sh-icon icon="draggable-vertical-s" class="drag-icon row-drag" button cdkDragHandle>
            </sh-icon>

            <!-- logic dropdown (AND / OR) -->
            <sh-dropdown *ngIf="ci === 0" [id]="'tt-and-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                class="logic-dropdown parent-logic" [label]="''" [ngModel]="groupIndex === 0 ? 'AND' : group.logic"
                (ngModelChange)="groupIndex !== 0 ? group.logic = $event : null" [disabled]="groupIndex === 0">

                <sh-menu-item *ngIf="groupIndex > 0" label="AND" [value]="'AND'"></sh-menu-item>
                <sh-menu-item *ngIf="groupIndex > 0" label="OR" [value]="'OR'"></sh-menu-item>
            </sh-dropdown>
            <sh-tooltip *ngIf="ci === 0 && groupIndex > 0" delay
                [target]="'tt-and-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                [label]="'filter-criteria.tooltip.logicOperator' | translate" placement="top"
                variation="short"></sh-tooltip>

            <sh-dropdown *ngIf="ci > 0" [id]="'tt-and-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                class="logic-dropdown"
                [ngClass]="{ 'parent-logic': !cond.depth || cond.depth === 0, 'child-logic': cond.depth == 1, 'sub-child-logic': cond.depth == 2 }"
                [label]="''" [(ngModel)]="cond.logic" [disabled]="dataService.isRolloutUpdated">

                <sh-menu-item label="AND" [value]="'AND'"></sh-menu-item>
                <sh-menu-item label="OR" [value]="'OR'"></sh-menu-item>
            </sh-dropdown>
            <sh-tooltip *ngIf="ci > 0" delay [target]="'tt-and-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                [label]="'filter-criteria.tooltip.logicOperator' | translate" placement="top"
                variation="short"></sh-tooltip>

            <!-- FIELD -->
            <sh-dropdown [id]="'tt-field-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                label="Select Filter Criteria" class="field-dropdown" [(ngModel)]="cond.field"
                (ngModelChange)="onFieldChange(cond)" placeholder="Select Filter Criteria"
                [displayWith]="displayFieldLabel" [disabled]="dataService.isRolloutUpdated" editable>

                <sh-menu-item *ngFor="let f of filterCriteriaDataService.filteredFields" [label]="f.label">
                </sh-menu-item>
            </sh-dropdown>
            <sh-tooltip delay [target]="'tt-field-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                [label]="'filter-criteria.tooltip.selectFilterCriteria' | translate" placement="top"
                variation="long"></sh-tooltip>

            <!-- OPERATOR -->
            <sh-dropdown [id]="'tt-op-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci" class="operator-dropdown"
                label="Select Operator" [(ngModel)]="cond.operator" (ngModelChange)="onOperatorChange(cond)"
                placeholder="Select Operator" [disabled]="isOperatorDropdownDisabled(cond)">

                <sh-menu-item *ngFor="let op of getOperatorsForField(cond.field)"
                    [value]="filterCriteriaDataService.getOperatorsLabel(op)"
                    [label]="filterCriteriaDataService.getOperatorsLabel(op)">
                </sh-menu-item>
            </sh-dropdown>
            <sh-tooltip delay [target]="'tt-op-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                [label]="'filter-criteria.tooltip.selectOperator' | translate" placement="top"
                variation="long"></sh-tooltip>

            <!-- VALUE controls (same logic as before) -->

            <!-- Country multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Country'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="Country(s)"
                class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let c of filterCriteriaDataService.countries"
                    [value]="c.name ? c.name + ' (' + c.id + ')' : c.id"
                    [label]="c.name ? c.name + ' (' + c.id + ')' : c.id">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Service Partner autocomplete -->
            <auto-complete [ngClass]="{ 'hidden': !filterCriteriaDataService.showServicePartnerField(cond.field) }"
                [inputControl]="cond.servicePartnerControl!"
                [searchArray]="filterCriteriaDataService.filteredPartnerMap[cond.id] || []"
                [defaultValue]="filterCriteriaDataService.partnerSearchTextMap[cond.id]" [label]="'Service Partner'"
                [displayField]="'name'" [valueField]="'id'" [multiSelect]="true"
                (inputChanged)="filterCriteriaDataService.onPartnerInput($event, cond)"
                (selected)="onPartnerSelected($event, cond)" [disabled]="dataService.isRolloutUpdated">
            </auto-complete>

            <!-- Date picker (from / to) -->
            <sh-input-text [ngClass]="{ 'hidden': !filterCriteriaDataService.showDatePickerField(cond.field) }"
                [(ngModel)]="cond.value" class="date-field" label="" type="date"
                [disabled]="dataService.isRolloutUpdated || (cond.field === 'Contract Date' && filterCriteriaDataService.contractDateEnabled) || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            </sh-input-text>

            <sh-input-text [ngClass]="{
                      'hidden':
                        !filterCriteriaDataService.showToDatePickerField(cond.field, cond.operator)
                    }" [(ngModel)]="cond.valueTo" class="date-field" label="" type="date"
                [disabled]="dataService.isRolloutUpdated || (cond.field === 'Contract Date' && filterCriteriaDataService.contractDateEnabled) || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            </sh-input-text>

            <!-- ADD HERE: Date range validation error -->
            <span
                *ngIf="filterCriteriaDataService.showDatePickerField(cond.field) && filterCriteriaDataService.isDateRangeOperator(cond.operator) && getDateRangeError(cond)"
                class="date-range-error" style="color: red; font-size: 12px; min-width: 200px;">
                {{ getDateRangeError(cond) }}
            </span>

            <!-- EQ Status multi-select -->
            <sh-dropdown *ngIf="cond.field === 'EQ Status'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="EQ Status"
                class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let opt of filterCriteriaDataService.eqStatusOptions" [value]="opt"
                    [label]="toTitleCase(opt)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- EQ Substatus multi-select -->
            <sh-dropdown *ngIf="cond.field === 'EQ Substatus'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="EQ Substatus" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let opt of filterCriteriaDataService.eqSubstatusOptions" [value]="opt"
                    [label]="toTitleCase(opt)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- RUH Ready Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'RUH Ready Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="RUH Ready Flag" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- RUH Not Allowed by Customer multi-select -->
            <sh-dropdown *ngIf="cond.field === 'RUH Not Allowed by Customer'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="RUH Not Allowed by Customer" class="query-dropdown" [(ngModel)]="cond.value" multi-select
                editable display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- ASU Ready Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'ASU Ready Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="ASU Ready Flag" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- ASU Not Allowed by Customer multi-select -->
            <sh-dropdown *ngIf="cond.field === 'ASU Not Allowed by Customer'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="ASU Not Allowed by Customer" class="query-dropdown" [(ngModel)]="cond.value" multi-select
                editable display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- RU Contract Status multi-select -->
            <sh-dropdown *ngIf="cond.field === 'RU Contract Status'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="RU Contract Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- RU Contract Sub Status multi-select -->
            <sh-dropdown *ngIf="cond.field === 'RU Contract Sub Status'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="RU Contract Sub Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- DA SW Upgrade multi-select -->
            <sh-dropdown *ngIf="cond.field === 'DA_SW Upgrade'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="DA SW Upgrade" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- DA SW Upgrade Value multi-select -->
            <sh-dropdown *ngIf="cond.field === 'DA_SW Upgrade Value'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="DA SW Upgrade Value" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- DA SW Update multi-select -->
            <sh-dropdown *ngIf="cond.field === 'DA_SW Update'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="DA SW Update" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- DA SW Update Value multi-select -->
            <sh-dropdown *ngIf="cond.field === 'DA_SW Update Value'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="DA SW Update Value" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- HQ Contract Status multi-select -->
            <sh-dropdown *ngIf="cond.field === 'HQ Contract Status'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="HQ Contract Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- HQ Contract Substatus multi-select -->
            <sh-dropdown *ngIf="cond.field === 'HQ Contract Substatus'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="HQ Contract Substatus" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Service Partner Type multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Service Partner Type'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Service Partner Type" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let spt of filterCriteriaDataService.servicePartnerTypes" [value]="spt.id"
                    [label]="spt.id + ' - ' + spt.name">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Update Handling Priority multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Update Handling Priority'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Update Handling Priority" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item [value]="'l'" [label]="'l - low'"></sh-menu-item>
                <sh-menu-item [value]="'m'" [label]="'m - medium'"></sh-menu-item>
                <sh-menu-item [value]="'h'" [label]="'h - high'"></sh-menu-item>
            </sh-dropdown>

            <!-- Service Provider Type multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Service Provider Type'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Service Provider Type" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- RSWD Environment multi-select -->
            <sh-dropdown *ngIf="cond.field === 'RSWD Environment'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="RSWD Environment" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Inhouse Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Inhouse Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Inhouse Flag" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Refurbished / Reconditioned multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Refurbished / Reconditioned'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Refurbished / Reconditioned" class="query-dropdown" [(ngModel)]="cond.value" multi-select
                editable display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Demo Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Demo Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="Demo Flag"
                class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- EQ Solution Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'EQ Solution Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="EQ Solution Flag" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- EoS Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'EoS Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="EoS Flag"
                class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- CTH Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'CTH Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="CTH Flag"
                class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- ES Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'ES Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="ES Flag"
                class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Embargo Flag multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Embargo Flag'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Embargo Flag" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- SAP Update Status multi-select -->
            <sh-dropdown *ngIf="cond.field === 'SAP Update Status'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="SAP Update Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="val">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Business Line multi-select -->
            <sh-dropdown *ngIf="cond.field === 'Business Line'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="Business Line(s)" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label" [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let bl of filterCriteriaDataService.businessLines" [value]="bl.name"
                    [label]="bl.name">
                </sh-menu-item>
            </sh-dropdown>
            <sh-dropdown *ngIf="cond.field === 'Contract Type'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showDropdownField(cond.field) }" label="Contract Type"
                class="query-dropdown" [(ngModel)]="cond.value" display="label"
                (ngModelChange)="filterCriteriaDataService.updateContractOptions()"
                [disabled]="dataService.isRolloutUpdated">
                <sh-menu-item *ngFor="let ct of filterCriteriaDataService.contract" [value]="ct"
                    [label]="toTitleCase(ct)">
                </sh-menu-item>
            </sh-dropdown>
            <!-- VAS Type multi-select -->
            <sh-dropdown *ngIf="cond.field === 'VAS Type'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="VAS Type(s)" class="query-dropdown" [(ngModel)]="cond.value"
                (ngModelChange)="updateVasLevelOptions()" multi-select editable
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.contractOptions">
                <sh-menu-item *ngFor="let vt of filterCriteriaDataService.vasTypes" [value]="vt.id"
                    [label]="vt.id + ' - ' + vt.name">
                </sh-menu-item>
            </sh-dropdown>

            <!-- VAS Level multi-select -->
            <sh-dropdown *ngIf="cond.field === 'VAS Level'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
                label="VAS Level(s)" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
                display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.vasLevelOptions.length === 0 || filterCriteriaDataService.contractOptions">
                <sh-menu-item *ngFor="let vl of filterCriteriaDataService.vasLevelOptions" [value]="vl.level"
                    [label]="vl.level + ' - ' + vl.name">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Simple dropdown value -->
            <sh-dropdown *ngIf="cond.field !== 'Contract Type'"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showDropdownField(cond.field) }"
                class="query-dropdown" [(ngModel)]="cond.value" label="Value" display="label"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)"
                editable>
                <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                    [label]="toTitleCase(val)">
                </sh-menu-item>
            </sh-dropdown>

            <!-- Text value -->
            <sh-input-text [id]="'tt-val-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                [ngClass]="{ 'hidden': !filterCriteriaDataService.showTextField(cond.field, cond.operator) }"
                [ngModel]="getConditionDisplayValue(cond)"
                (paste)="onValuePaste($event, cond)"
                (ngModelChange)="onConditionDisplayValueChange($event, cond); onCombinationValueChange(cond); filterCriteriaDataService.isMaterialNoField(cond.field) && onIVKValueChange(cond)"
                class="value-text-input" [label]="getTextFieldPlaceholder(cond.field, cond.operator)"
                [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            </sh-input-text>
            <sh-tooltip *ngIf="filterCriteriaDataService.showTextField(cond.field, cond.operator)" delay
                [target]="'tt-val-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                [label]="'filter-criteria.tooltip.enterValue' | translate" placement="top"
                variation="short"></sh-tooltip>

            <!-- IVK inline display -->
            <ng-container
                *ngIf="filterCriteriaDataService.isMaterialNoField(cond.field) && shouldShowIVKStatus(cond.value, cond.id)">
                <sh-icon *ngIf="checkForInvalidIVKs(cond.value, cond.id)" icon="warning-triangle" button size="m" class="ivk-more-icon"
                    title="View all IVK descriptions" (click)="openIVKModal(cond.id.toString(), getConditionDisplayValue(cond))"
                    (keydown.enter)="openIVKModal(cond.id.toString(), getConditionDisplayValue(cond))">
                </sh-icon>
                <!-- Multiple results: show only icon -->
                <sh-icon *ngIf="shouldShowIVKInfoIcon(cond.value, cond.id)" icon="information" button size="s" class="ivk-more-icon"
                    title="View all IVK descriptions" (click)="openIVKModal(cond.id.toString(), getConditionDisplayValue(cond))"
                    (keydown.enter)="openIVKModal(cond.id.toString(), getConditionDisplayValue(cond))">
                </sh-icon>
                <span *ngIf="hasIgnoredIVKs(cond.id.toString())" class="ivk-inline-text">
                    Errors ignored
                </span>
            </ng-container>

            <!-- Combination validation error -->
            <div *ngIf="cond.operator === 'combination' && filterCriteriaDataService.combinationErrors[cond.id]"
                class="combination-error" style="color: #f44336; font-size: 12px; margin-top: 2px; min-width: 200px;">
                {{ filterCriteriaDataService.combinationErrors[cond.id] }}
            </div>

            <!-- ROW ACTIONS: -, +, ... -->
            <div class="row-actions">
                <sh-icon [id]="'tt-rmrow-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci" icon="minus-light"
                    class="row-action-icon" button (click)="removeCondition(groupIndex, ci)"
                    [disabled]="dataService.isRolloutUpdated">
                </sh-icon>
                <sh-tooltip delay [target]="'tt-rmrow-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                    [label]="'filter-criteria.tooltip.removeRow' | translate" placement="top"
                    variation="short"></sh-tooltip>

                <sh-icon *ngIf="canAddChild(cond)"
                    [id]="'tt-addrow-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci" icon="plus-light"
                    class="row-action-icon" button (click)="addCondition(groupIndex, 'OR', ci)"
                    [disabled]="dataService.isRolloutUpdated">
                </sh-icon>
                <sh-tooltip *ngIf="canAddChild(cond)" delay
                    [target]="'tt-addrow-' + (isModal ? 'm' : 'p') + '-' + groupIndex + '-' + ci"
                    [label]="'filter-criteria.tooltip.addRow' | translate" placement="top"
                    variation="short"></sh-tooltip>

                <div *ngIf="!canAddChild(cond) && (cond.depth || 0) < 2" class="row-action-placeholder"></div>

                <sh-icon icon="more" class="row-action-icon more-trigger" button
                    [id]="'more-target-' + groupIndex + '-' + ci"
                    (click)="shouldShowMoreMenu(cond) && toggleRowMenu(cond.id)"
                    [disabled]="!shouldShowMoreMenu(cond) || dataService.isRolloutUpdated"
                    [style.opacity]="shouldShowMoreMenu(cond) ? 1 : 0.3"
                    [style.cursor]="shouldShowMoreMenu(cond) ? 'pointer' : 'not-allowed'">
                </sh-icon>
                <sh-tooltip *ngIf="shouldShowMoreMenu(cond)" delay [target]="'more-target-' + groupIndex + '-' + ci"
                    [label]="'filter-criteria.tooltip.moreActions' | translate" placement="top"
                    variation="short"></sh-tooltip>
            </div>

            <sh-popover *ngIf="shouldShowMoreMenu(cond) && activeRowMenu === cond.id" [visible]="true"
                [target]="'more-target-' + groupIndex + '-' + ci" placement="left-start">
                <sh-menu-item label="Upload File" icon="upload" (click)="fileInput.click(); closeRowMenu()">
                </sh-menu-item>
                <sh-divider *ngIf="showUploadField(cond.field) && hasRangeValues(cond)"></sh-divider>
                <sh-menu-item label="Include/Exclude" icon="fullscreen"
                    (click)="openSingleValueModal(cond); closeRowMenu()">
                </sh-menu-item>
            </sh-popover>

            <!-- hidden file input per row -->
            <input #fileInput type="file" accept=".xlsx" hidden (change)="onFileUpload($event, cond)"
                [disabled]="dataService.isRolloutUpdated" />
        </div>
    </div>
</div>

<!-- IVK Description Modal -->
<sh-modal [visible]="showIvkModal" label="IVK Descriptions" modal-height="550px" modal-width="700px"
    style="z-index: 104" (modal-closed)="showIvkModal = false">

    <sh-table condensed class="ivk-modal-table" style="margin-bottom: 0px !important">
        <sh-table-row slot="header" condensed>
            <sh-table-head [columns]="3" unsortable></sh-table-head>
            <sh-table-head [columns]="5" unsortable>Material No.</sh-table-head>
            <sh-table-head [columns]="12" unsortable>IVK Description</sh-table-head>
            <sh-table-head [columns]="4" unsortable>Type</sh-table-head>
        </sh-table-row>
        <sh-table-row *ngFor="let item of ivkModalData" condensed>
            <sh-table-cell [columns]="3">
                <sh-checkbox
                    *ngIf="item.type === 'Error'"
                    [active]="item.isActive"
                    (checked)="toggleIvkErrorSelection(item.matNo, $event)" >
                </sh-checkbox>
            </sh-table-cell>
            <sh-table-cell [columns]="5">
                <sh-text size="body-2" *ngIf="!showIvkDescriptionInput(item)">
                    {{ item.matNo }}
                </sh-text>
                 <sh-input-text 
                    *ngIf="showIvkDescriptionInput(item)"
                    class="material_no"
                    type="text" 
                    condensed
                    [(ngModel)]="item.matNo"
                    (ngModelChange)="onIVKChange($event, item)">
                </sh-input-text>
            </sh-table-cell>
            <sh-table-cell [columns]="12">
                <sh-text size="body-2">
                    {{ item.ivkDescription }}
                </sh-text>
            </sh-table-cell>
            <sh-table-cell [columns]="4">
                <span [style.color]="item.type === 'Error' ? '#ff9800' : item.type === 'Excluded' ? '#f44336' : '#4caf50'" [style.font-weight]="'bold'"
                    [style.font-size]="'12px'">
                    {{ item.type }}
                </span>
            </sh-table-cell>
        </sh-table-row>
        <sh-table-row *ngIf="ivkModalData.length === 0" condensed>
            <sh-table-cell [columns]="24">No data available</sh-table-cell>
        </sh-table-row>
    </sh-table>

    <sh-button [disabled]="!hasActiveIvkErrorSelection()" slot="footer" size="auto" label="Ignore Error" (click)="ignoreIvkErrors()" (keydown)="ignoreIvkErrors()"></sh-button>
    <sh-button [disabled]="!hasActiveIvkErrorSelection()" slot="footer" size="auto" label="Remove Error" (click)="removeSelectedIvkErrors()" (keydown)="removeSelectedIvkErrors()"></sh-button>
</sh-modal>

<!-- Delete Group Confirmation Modal -->
<sh-modal
    [visible]="showDeleteGroupModal"
    label="Delete Group"
    modal-height='200px'
    modal-width='450px'
    style="z-index: 107;"
    (modal-closed)="cancelDeleteGroup()">

    <sh-text size="body">
        Are you sure you want to delete this group and its notes? This action cannot be undone.
    </sh-text>

    <div slot="footer" class="modal-footer-buttons">
        <sh-button
            color="secondary"
            label="Cancel"
            (click)="cancelDeleteGroup()"
            (keydown.enter)="cancelDeleteGroup()">
        </sh-button>
        <sh-button
            color="primary"
            [label]="isDeletingGroup ? 'Deleting...' : 'Delete'"
            (click)="confirmDeleteGroup()"
            (keydown.enter)="confirmDeleteGroup()"
            [disabled]="isDeletingGroup">
        </sh-button>
    </div>
</sh-modal>

<!--Right now using duplicate html code for previewing drag and drop as same as the filter criteria-->
<ng-template #dragConditionsToBeMoved let-ci="ci" let-cond="cond" let-group="group" let-groupIndex="groupIndex">
    <div class="drag-preview" [ngClass]="{ 'nested-row': cond.depth && cond.depth > 0 }"
        [style.padding-left.px]="getRowPadding(cond)">
        <sh-icon icon="draggable-vertical-s" class="drag-icon row-drag" button cdkDragHandle>
        </sh-icon>

        <!-- logic dropdown (AND / OR) -->
        <sh-dropdown class="logic-dropdown"
            [ngClass]="{ 'parent-logic': !cond.depth || cond.depth === 0, 'child-logic': cond.depth == 1, 'sub-child-logic': cond.depth == 2 }"
            [label]="''" [(ngModel)]="cond.logic" [disabled]="dataService.isRolloutUpdated">

            <sh-menu-item label="AND" [value]="'AND'"></sh-menu-item>
            <sh-menu-item label="OR" [value]="'OR'"></sh-menu-item>
        </sh-dropdown>

        <!-- FIELD -->
        <sh-dropdown label="Select Filter Criteria" class="field-dropdown" [(ngModel)]="cond.field"
            placeholder="Select Filter Criteria" [displayWith]="displayFieldLabel"
            [disabled]="dataService.isRolloutUpdated">

            <sh-menu-item *ngFor="let f of filterCriteriaDataService.filteredFields" [label]="f.label">
            </sh-menu-item>
        </sh-dropdown>

        <!-- OPERATOR -->
        <sh-dropdown class="operator-dropdown" label="Select Operator" [(ngModel)]="cond.operator"
            placeholder="Select Operator" [disabled]="isOperatorDropdownDisabled(cond)">

            <sh-menu-item *ngFor="let op of getOperatorsForField(cond.field)"
                [value]="filterCriteriaDataService.getOperatorsLabel(op)"
                [label]="filterCriteriaDataService.getOperatorsLabel(op)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- VALUE controls (same logic as before) -->

        <!-- Country multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Country'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="Country(s)"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let c of filterCriteriaDataService.countries"
                [value]="c.name ? c.name + ' (' + c.id + ')' : c.id"
                [label]="c.name ? c.name + ' (' + c.id + ')' : c.id">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Service Partner autocomplete -->
        <auto-complete [ngClass]="{ 'hidden': !filterCriteriaDataService.showServicePartnerField(cond.field) }"
            [inputControl]="cond.servicePartnerControl!"
            [searchArray]="filterCriteriaDataService.filteredPartnerMap[cond.id] || []"
            [defaultValue]="filterCriteriaDataService.partnerSearchTextMap[cond.id]" [label]="'Service Partner'"
            [displayField]="'name'" [valueField]="'id'" [multiSelect]="true" (selected)="onPartnerSelected($event, cond)"
            [disabled]="dataService.isRolloutUpdated">
        </auto-complete>

        <!-- Date picker (from / to) -->
        <sh-input-text [ngClass]="{ 'hidden': !filterCriteriaDataService.showDatePickerField(cond.field) }"
            [(ngModel)]="cond.value" class="date-field" label="" type="date"
            [disabled]="dataService.isRolloutUpdated || (cond.field == 'Contract Date' && filterCriteriaDataService.contractDateEnabled)">
        </sh-input-text>

        <sh-input-text [ngClass]="{
      'hidden':
      !filterCriteriaDataService.showDatePickerField(cond.field) ||
      !filterCriteriaDataService.isDateRangeOperator(cond.operator)
    }" [(ngModel)]="cond.valueTo" class="date-field" label="" type="date"
            [disabled]="dataService.isRolloutUpdated || (cond.field == 'Contract Date' && filterCriteriaDataService.contractDateEnabled)">
        </sh-input-text>

        <!-- Business Line multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Business Line'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="Business Line(s)" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let bl of filterCriteriaDataService.businessLines" [value]="bl.name"
                [label]="bl.name">
            </sh-menu-item>
        </sh-dropdown>

        <!-- VAS Type multi-select -->
        <sh-dropdown *ngIf="cond.field === 'VAS Type'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="VAS Type(s)"
            class="query-dropdown" [(ngModel)]="cond.value" (ngModelChange)="updateVasLevelOptions()" multi-select
            editable [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let vt of filterCriteriaDataService.vasTypes" [value]="vt.id"
                [label]="vt.id + ' - ' + vt.name">
            </sh-menu-item>
        </sh-dropdown>

        <!-- VAS Level multi-select -->
        <sh-dropdown *ngIf="cond.field === 'VAS Level'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="VAS Level(s)"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.vasLevelOptions.length === 0">
            <sh-menu-item *ngFor="let vl of filterCriteriaDataService.vasLevelOptions" [value]="vl.level"
                [label]="vl.level + ' - ' + vl.name">
            </sh-menu-item>
        </sh-dropdown>

        <!-- RUH Ready Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'RUH Ready Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="RUH Ready Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- RUH Not Allowed by Customer multi-select -->
        <sh-dropdown *ngIf="cond.field === 'RUH Not Allowed by Customer'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="RUH Not Allowed by Customer" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- ASU Ready Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'ASU Ready Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="ASU Ready Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- ASU Not Allowed by Customer multi-select -->
        <sh-dropdown *ngIf="cond.field === 'ASU Not Allowed by Customer'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="ASU Not Allowed by Customer" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- RU Contract Status multi-select -->
        <sh-dropdown *ngIf="cond.field === 'RU Contract Status'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="RU Contract Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- RU Contract Sub Status multi-select -->
        <sh-dropdown *ngIf="cond.field === 'RU Contract Sub Status'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="RU Contract Sub Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- DA SW Upgrade multi-select -->
        <sh-dropdown *ngIf="cond.field === 'DA_SW Upgrade'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="DA SW Upgrade"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- DA SW Upgrade Value multi-select -->
        <sh-dropdown *ngIf="cond.field === 'DA_SW Upgrade Value'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="DA SW Upgrade Value" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- DA SW Update multi-select -->
        <sh-dropdown *ngIf="cond.field === 'DA_SW Update'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="DA SW Update"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- DA SW Update Value multi-select -->
        <sh-dropdown *ngIf="cond.field === 'DA_SW Update Value'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="DA SW Update Value" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- HQ Contract Status multi-select -->
        <sh-dropdown *ngIf="cond.field === 'HQ Contract Status'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="HQ Contract Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- HQ Contract Substatus multi-select -->
        <sh-dropdown *ngIf="cond.field === 'HQ Contract Substatus'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="HQ Contract Substatus" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label"
            [disabled]="dataService.isRolloutUpdated || filterCriteriaDataService.isFieldDisabledByContractType(cond.field)">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Service Partner Type multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Service Partner Type'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="Service Partner Type" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let spt of filterCriteriaDataService.servicePartnerTypes" [value]="spt.id"
                [label]="spt.id + ' - ' + spt.name">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Service Provider Type multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Service Provider Type'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="Service Provider Type" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- RSWD Environment multi-select -->
        <sh-dropdown *ngIf="cond.field === 'RSWD Environment'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="RSWD Environment" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Inhouse Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Inhouse Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="Inhouse Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Refurbished / Reconditioned multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Refurbished / Reconditioned'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="Refurbished / Reconditioned" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Demo Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Demo Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="Demo Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- EQ Solution Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'EQ Solution Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="EQ Solution Flag" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- EoS Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'EoS Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="EoS Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- CTH Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'CTH Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="CTH Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- ES Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'ES Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="ES Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Embargo Flag multi-select -->
        <sh-dropdown *ngIf="cond.field === 'Embargo Flag'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }" label="Embargo Flag"
            class="query-dropdown" [(ngModel)]="cond.value" multi-select editable display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="toTitleCase(val)">
            </sh-menu-item>
        </sh-dropdown>

        <!-- SAP Update Status multi-select -->
        <sh-dropdown *ngIf="cond.field === 'SAP Update Status'"
            [ngClass]="{ 'hidden': !filterCriteriaDataService.showMultiselectField(cond.field) }"
            label="SAP Update Status" class="query-dropdown" [(ngModel)]="cond.value" multi-select editable
            display="label" [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)" [value]="val"
                [label]="val">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Simple dropdown value -->
        <sh-dropdown [ngClass]="{ 'hidden': !filterCriteriaDataService.showDropdownField(cond.field) }"
            class="field-dropdown" [(ngModel)]="cond.value" label="Value" display="label"
            [disabled]="dataService.isRolloutUpdated">
            <sh-menu-item *ngFor="let val of filterCriteriaDataService.getValueOptions(cond.field)"
                [label]="toTitleCase(val)" [value]="val">
            </sh-menu-item>
        </sh-dropdown>

        <!-- Text value -->
        <sh-input-text [ngClass]="{ 'hidden': !filterCriteriaDataService.showTextField(cond.field, cond.operator) }"
            [(ngModel)]="cond.value" (paste)="onValuePaste($event, cond)" (ngModelChange)="onCombinationValueChange(cond)" class="value-text-input"
            [label]="getTextFieldPlaceholder(cond.field, cond.operator)" [disabled]="dataService.isRolloutUpdated">
        </sh-input-text>
    </div>
</ng-template>
<app-notification *ngIf="notification" [notification]="notification"></app-notification>